import React from "react";

import { Header, SectionTable } from "../components";


const Sections = () => {
    return (
        <div className="mainpanel">
            {/* <!-- pageheader --> */}
            <Header title="Section" />

            <div className="contentpanel">
                {/* <!-- col-md-6 --> */}
                <div className="col-md-12">
                <h3>All Sections</h3>
                    <SectionTable />
                </div>
            </div>
        </div>
    );
};

export default Sections;
